<template>
  <v-flex v-if="member != null">
    <h2 class="display-3 display-3_dark">
      {{ getJoblessQuestions.members.label }} - {{ member.name }}
    </h2>
    <p class="f-1">
      {{ $t('sheet.sheetOne.meeting.jobless.hint') }}
    </p>
    <ul class="questions-list">
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('exp')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.exp.required }"
        >
          {{ getJoblessQuestions.members.exp.label }}
        </p>
        <v-textarea
          v-model="member.exp"
          v-validate="{ ...requiredRegularField(getJoblessQuestions.members.exp.required) }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('experience'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('experience')"
          :required="getJoblessQuestions.members.exp.required"
          auto-grow
        />
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('howLong')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.howLong.required }"
        >
          {{ getJoblessQuestions.members.howLong.label }}
        </p>
        <v-radio-group
          v-model="member.howLong"
          v-validate="{ required: getJoblessQuestions.members.howLong.required }"
          :disabled="readOnly"
          class="mt-0 pt-0"
          :error-messages="errors.collect(compoundVVName('howLong'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('howLong')"
          :required="getJoblessQuestions.members.howLong.required"
        >
          <v-radio
            v-for="(item, index) in howLongItems"
            :key="index"
            off-icon=""
            on-icon=""
            :value="item.id"
            :label="item.description"
          />
        </v-radio-group>
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('obstacles')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.obstacles.required }"
        >
          {{ getJoblessQuestions.members.obstacles.label }}
        </p>
        <ConfirmButtons
          v-if="isCurrentEdition"
          v-model="member.obstacles"
          v-validate="{ required: getJoblessQuestions.members.obstacles.required }"
          string
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.obstacles'))"
          data-vv-as=" "
          :data-vv-name="compoundVVName('member.obstacles')"
        />
        <v-textarea
          v-else
          v-model="member.obstacles"
          v-validate="{ ...requiredRegularField(getJoblessQuestions.members.obstacles.required) }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.obstacles'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('member.obstacles')"
          :required="getJoblessQuestions.members.obstacles.required"
          auto-grow
        />
      </li>
      <li
        v-if="
          getJoblessQuestions.members.hasOwnProperty('obstacles_description') &&
            member.obstacles === 'yes'
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getJoblessQuestions.members.obstacles_description.required }"
        >
          {{ getJoblessQuestions.members.obstacles_description.label }}
        </p>
        <v-textarea
          v-model="member.obstaclesDescription"
          v-validate="{
            ...regularLongText(getJoblessQuestions.members.obstacles_description.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('obstaclesDescription'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('obstaclesDescription')"
          :required="getJoblessQuestions.members.obstacles_description.required"
          auto-grow
        />
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('cause')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.cause.required }"
        >
          {{ getJoblessQuestions.members.cause.label }}
        </p>
        <v-textarea
          v-model="member.cause"
          v-validate="{ ...requiredRegularField(getJoblessQuestions.members.cause.required) }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('cause'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('cause')"
          :required="getJoblessQuestions.members.cause.required"
          auto-grow
        />
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('what_at_work')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.what_at_work.required }"
        >
          {{ getJoblessQuestions.members.what_at_work.label }}
        </p>
        <v-textarea
          v-model="member.whatAtWork"
          v-validate="{
            ...requiredRegularField(getJoblessQuestions.members.what_at_work.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('whatToDo'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('whatToDo')"
          :required="getJoblessQuestions.members.what_at_work.required"
          auto-grow
        />
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('selected_expectations')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.selected_expectations.required }"
        >
          {{ getJoblessQuestions.members.selected_expectations.label }}
        </p>
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in expectationsList"
            :key="index"
            md4
            sm6
            xs12
          >
            <v-checkbox
              v-model="member.selectedExpectations"
              v-validate="{ required: getJoblessQuestions.members.selected_expectations.required }"
              multiple
              :disabled="readOnly"
              :label="item.description"
              :value="item.id"
              :error="errors.has(compoundVVName('member.selectedExpectations'))"
              :error-messages="
                index + 1 === expectationsList.length
                  ? errors.collect(compoundVVName('member.selectedExpectations'))
                  : null
              "
              :data-vv-as="$t('label.question')"
              :data-vv-name="compoundVVName('member.selectedExpectations')"
            />
          </v-flex>
        </v-layout>
        <div
          v-if="
            otherExpectations && getJoblessQuestions.members.hasOwnProperty('other_expectation')
          "
        >
          <p
            class="fw-600 mt-4"
            :class="{ required: getJoblessQuestions.members.other_expectation.required }"
          >
            {{ getJoblessQuestions.members.other_expectation.label }}
          </p>
          <v-textarea
            v-model="member.otherExpectation"
            v-validate="{
              ...requiredRegularField(getJoblessQuestions.members.other_expectation.required)
            }"
            :placeholder="$t('placeholders.add_text')"
            :disabled="readOnly"
            :error-messages="errors.collect(compoundVVName('otherExpectation'))"
            :data-vv-as="$t('label.question')"
            :data-vv-name="compoundVVName('otherExpectation')"
            class="small"
            auto-grow
          />
        </div>
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('looking_for_work')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.looking_for_work.required }"
        >
          {{ getJoblessQuestions.members.looking_for_work.label }}
        </p>
        <ConfirmButtons
          v-model="member.lookingForWork"
          v-validate="{ required: getJoblessQuestions.members.looking_for_work.required }"
          string
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.lookingForWork'))"
          data-vv-as=" "
          :data-vv-name="compoundVVName('member.lookingForWork')"
        />
        <div
          v-if="
            member.lookingForWork === 'yes' &&
              getJoblessQuestions.members.hasOwnProperty('selected_announcements')
          "
        >
          <p
            class="header custom lA mt-4"
            :class="{ required: getJoblessQuestions.members.selected_announcements.required }"
          >
            {{ getJoblessQuestions.members.selected_announcements.label }}
          </p>
          <v-layout wrap>
            <v-flex
              v-for="(item, index) in announcementsList"
              :key="index"
              md4
              sm6
              xs12
            >
              <v-checkbox
                v-model="member.selectedAnnouncements"
                v-validate="{
                  required: getJoblessQuestions.members.selected_announcements.required
                }"
                multiple
                :disabled="readOnly"
                :label="item.description"
                :value="item.id"
                :error="errors.has(compoundVVName('member.selectedAnnouncements'))"
                :error-messages="
                  index + 1 === announcementsList.length
                    ? errors.collect(compoundVVName('member.selectedAnnouncements'))
                    : null
                "
                :data-vv-as="$t('label.question')"
                :data-vv-name="compoundVVName('member.selectedAnnouncements')"
              />
            </v-flex>
          </v-layout>
          <div
            v-if="
              otherAnnouncements && getJoblessQuestions.members.hasOwnProperty('other_announcement')
            "
          >
            <p
              class="fw-600 mt-4"
              :class="{ required: getJoblessQuestions.members.other_announcement.required }"
            >
              {{ getJoblessQuestions.members.other_announcement.label }}
            </p>
            <v-textarea
              v-model="member.otherAnnouncement"
              v-validate="{
                ...requiredRegularField(getJoblessQuestions.members.other_announcement.required)
              }"
              :placeholder="$t('placeholders.add_text')"
              :disabled="readOnly"
              :error-messages="errors.collect(compoundVVName('otherAnnouncement'))"
              :data-vv-as="$t('label.question')"
              :data-vv-name="compoundVVName('otherAnnouncement')"
              :required="getJoblessQuestions.members.other_announcement.required"
              auto-grow
            />
          </div>
        </div>
        <div
          v-if="
            !isCurrentEdition &&
              member.lookingForWork === 'yes' &&
              getJoblessQuestions.members.hasOwnProperty('found_interesting')
          "
        >
          <p
            class="header custom lB mt-4"
            :class="{ required: getJoblessQuestions.members.found_interesting.required }"
          >
            {{ getJoblessQuestions.members.found_interesting.label }}
          </p>
          <ConfirmButtons
            v-model="member.foundInteresting"
            v-validate="{ required: getJoblessQuestions.members.found_interesting.required }"
            string
            :disabled="readOnly"
            :error-messages="errors.collect(compoundVVName('member.foundInteresting'))"
            data-vv-as=" "
            :data-vv-name="compoundVVName('member.foundInteresting')"
          />
        </div>
        <div
          v-if="
            member.lookingForWork === 'yes' &&
              getJoblessQuestions.members.hasOwnProperty('job_invitation')
          "
        >
          <p
            class="header custom lB mt-4"
            :class="{ required: getJoblessQuestions.members.job_invitation.required }"
          >
            {{ getJoblessQuestions.members.job_invitation.label }}
          </p>
          <ConfirmButtons
            v-model="member.jobInvitation"
            v-validate="{ required: getJoblessQuestions.members.job_invitation.required }"
            string
            :disabled="readOnly"
            :error-messages="errors.collect(compoundVVName('member.jobInvitation'))"
            data-vv-as=" "
            :data-vv-name="compoundVVName('member.jobInvitation')"
          />
        </div>
        <div
          v-if="
            member.lookingForWork === 'yes' &&
              getJoblessQuestions.members.hasOwnProperty('cv_count')
          "
        >
          <p
            class="header custom lC mt-4"
            :class="{ required: getJoblessQuestions.members.cv_count.required }"
          >
            {{ getJoblessQuestions.members.cv_count.label }}
          </p>
          <v-layout align-cenetr>
            <p class="fw-600 mt-0 mr-3">
              {{ $t('label.amount_label') }}
            </p>
            <CounterButtons
              v-model="member.cvCount"
              v-validate="{ required: getJoblessQuestions.members.cv_count.required }"
              :disabled="readOnly"
              class="mr-4 none-growth"
              :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
              :error-messages="errors.collect(compoundVVName('member.cvCount'))"
              data-vv-as=" "
              :data-vv-name="compoundVVName('member.cvCount')"
            />
          </v-layout>
        </div>
        <div
          v-if="
            member.lookingForWork === 'no' &&
              getJoblessQuestions.members.hasOwnProperty('not_looking_for_work_explain')
          "
        >
          <p
            class="header custom lA mt-3"
            :class="{ required: getJoblessQuestions.members.not_looking_for_work_explain.required }"
          >
            {{ getJoblessQuestions.members.not_looking_for_work_explain.label }}
          </p>
          <v-textarea
            v-model="member.notLookingForWorkExplain"
            v-validate="{
              ...requiredRegularField(
                getJoblessQuestions.members.not_looking_for_work_explain.required
              )
            }"
            :placeholder="$t('placeholders.add_text')"
            :disabled="readOnly"
            :error-messages="errors.collect(compoundVVName('participatesExplain'))"
            :data-vv-as="$t('label.question')"
            :data-vv-name="compoundVVName('participatesExplain')"
            :required="getJoblessQuestions.members.not_looking_for_work_explain.required"
            auto-grow
          />
        </div>
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('participates')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.participates.required }"
        >
          {{ getJoblessQuestions.members.participates.label }}
        </p>
        <ConfirmButtons
          v-model="member.participates"
          v-validate="{ required: getJoblessQuestions.members.participates.required }"
          string
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.participates'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('member.participates')"
        />
      </li>
      <li
        v-if="
          member.participates === 'yes' &&
            getJoblessQuestions.members.hasOwnProperty('participates_explain')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getJoblessQuestions.members.participates_explain.required }"
        >
          {{ getJoblessQuestions.members.participates_explain.label }}
        </p>
        <v-textarea
          v-model="member.participatesExplain"
          v-validate="{
            ...requiredRegularField(getJoblessQuestions.members.participates_explain.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('participates'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('participates')"
          :required="getJoblessQuestions.members.participates_explain.required"
          auto-grow
        />
      </li>
      <li
        v-if="
          getJoblessQuestions.members.hasOwnProperty('cv_count') &&
            getJoblessQuestions.members.hasOwnProperty('interviews_count')
        "
        class="mt-4"
      >
        <p
          class="header"
          :class="{
            required:
              getJoblessQuestions.members.cv_count.required ||
              getJoblessQuestions.members.interviews_count.required
          }"
        >
          {{ getJoblessQuestions.members.cv_count.label }}
          {{ getJoblessQuestions.members.interviews_count.label }}
        </p>
        <v-layout wrap>
          <v-flex
            shrink
            mr-5
          >
            <v-layout column>
              <v-flex>
                <p class="fw-600 mt-0">
                  {{ $t('sheet.sheetOne.meeting.jobless.member.question_8_cv') }}
                </p>
              </v-flex>
              <v-flex>
                <CounterButtons
                  v-model="member.cvCount"
                  v-validate="{ required: getJoblessQuestions.members.cv_count.required }"
                  :disabled="readOnly"
                  class="mr-4 none-growth"
                  :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
                  :error-messages="errors.collect(compoundVVName('member.cvCount'))"
                  :data-vv-as="$t('label.question')"
                  :data-vv-name="compoundVVName('member.cvCount')"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            shrink
            :ml-5="$vuetify.breakpoint.smAndUp"
            :mt-3="$vuetify.breakpoint.xsOnly"
          >
            <v-layout column>
              <v-flex>
                <p class="fw-600 mt-0">
                  {{ $t('sheet.sheetOne.meeting.jobless.member.question_8_interviews') }}
                </p>
              </v-flex>
              <v-flex>
                <CounterButtons
                  v-model="member.interviewsCount"
                  v-validate="{ required: getJoblessQuestions.members.interviews_count.required }"
                  :disabled="readOnly"
                  class="mr-4 none-growth"
                  :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
                  :error-messages="errors.collect(compoundVVName('member.interviewsCount'))"
                  :data-vv-as="$t('label.question')"
                  :data-vv-name="compoundVVName('member.interviewsCount')"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </li>
      <li
        v-if="
          member.interviewsCount > 0 &&
            getJoblessQuestions.members.hasOwnProperty('interviews_explain')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getJoblessQuestions.members.interviews_explain.required }"
        >
          {{ getJoblessQuestions.members.interviews_explain.label }}
        </p>
        <v-textarea
          v-model="member.interviewsExplain"
          v-validate="{
            ...requiredRegularField(getJoblessQuestions.members.interviews_explain.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('interviewsExplain'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('interviewsExplain')"
          :required="getJoblessQuestions.members.interviews_explain.required"
          auto-grow
        />
      </li>
      <li
        v-if="showRefusedJobQuestion"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.refused_job.required }"
        >
          {{ getJoblessQuestions.members.refused_job.label }}
        </p>
        <ConfirmButtons
          v-model="member.refusedJob"
          v-validate="{ required: getJoblessQuestions.members.refused_job.required }"
          string
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.refusedJob'))"
          :data-vv-as="$t('label.question')"
          :data-vv-name="compoundVVName('member.refusedJob')"
        />
      </li>
      <li
        v-if="showSelectedJobRefusedQuestion"
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getJoblessQuestions.members.selected_job_refuse.required }"
        >
          {{ getJoblessQuestions.members.selected_job_refuse.label }}
        </p>
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in jobRefuseList"
            :key="index"
            md4
            sm6
            xs12
          >
            <v-checkbox
              v-model="member.selectedJobRefuse"
              v-validate="{ required: getJoblessQuestions.members.selected_job_refuse.required }"
              multiple
              :disabled="readOnly"
              :label="item.description"
              :value="item.id"
              :error="errors.has(compoundVVName('member.selectedJobRefuse'))"
              :error-messages="
                index + 1 === jobRefuseList.length
                  ? errors.collect(compoundVVName('member.selectedJobRefuse'))
                  : null
              "
              :data-vv-as="$t('label.question')"
              :data-vv-name="compoundVVName('member.selectedJobRefuse')"
            />
          </v-flex>
        </v-layout>
        <div
          v-if="
            selectedJobRefusal && getJoblessQuestions.members.hasOwnProperty('job_refuse_other')
          "
        >
          <p
            class="fw-600 mt-4"
            :class="{ required: getJoblessQuestions.members.job_refuse_other.required }"
          >
            {{ getJoblessQuestions.members.job_refuse_other.label }}
          </p>
          <v-textarea
            v-model="member.jobRefuseOther"
            v-validate="{
              ...requiredRegularField(getJoblessQuestions.members.job_refuse_other.required)
            }"
            :placeholder="$t('placeholders.add_text')"
            :disabled="readOnly"
            :error-messages="errors.collect(compoundVVName('jobRefuseOther'))"
            :data-vv-as="$t('label.question')"
            :data-vv-name="compoundVVName('jobRefuseOther')"
            :required="getJoblessQuestions.members.job_refuse_other.required"
            auto-grow
          />
        </div>
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('plan_to_find_a_job')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.plan_to_find_a_job.required }"
        >
          {{ getJoblessQuestions.members.plan_to_find_a_job.label }}
        </p>
        <v-textarea
          v-model="member.planToFindAJob"
          v-validate="{
            ...regularLongText(getJoblessQuestions.members.plan_to_find_a_job.required)
          }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('member.planToFindAJob'))"
          data-vv-as=" "
          :data-vv-name="compoundVVName('member.planToFindAJob')"
          :required="getJoblessQuestions.members.plan_to_find_a_job.required"
          auto-grow
        />
      </li>
      <li
        v-if="getJoblessQuestions.members.hasOwnProperty('job_for')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getJoblessQuestions.members.job_for.required }"
        >
          {{ getJoblessQuestions.members.job_for.label }}
        </p>
        <v-textarea
          v-model="member.jobFor"
          v-validate="{ ...requiredRegularField(getJoblessQuestions.members.job_for.required) }"
          :placeholder="$t('placeholders.add_text')"
          :disabled="readOnly"
          :error-messages="errors.collect(compoundVVName('jobFor'))"
          data-vv-as=" "
          :data-vv-name="compoundVVName('jobFor')"
          :required="getJoblessQuestions.members.job_for.required"
          auto-grow
        />
      </li>
    </ul>
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import CounterButtons from '@/components/widgets/sheet/CounterButtons';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import { mapGetters } from 'vuex';
import has from 'lodash.has';

export default {
    name: 'MemberForm',
    components: {
        ConfirmButtons,
        CounterButtons
    },
    mixins: [sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        value: {},
        readOnly: {
            default: false,
            type: Boolean
        },
        isCurrentEdition: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            member: null,
            emptyMembersData: {
                exp: null,
                howLong: null,
                cause: null,
                whatAtWork: null,
                selectedExpectations: [],
                otherExpectation: null,
                lookingForWork: null,
                selectedAnnouncements: [],
                otherAnnouncement: null,
                participates: null,
                participatesExplain: null,
                cvCount: null,
                interviewsCount: null,
                interviewsExplain: null,
                refusedJob: null,
                selectedJobRefuse: [],
                jobRefuseOther: null,
                obstacles: null,
                obstaclesDescription: null,
                jobFor: null,
                notLookingForWorkExplain: null,
                foundInteresting: null,
                jobInvitation: null,
                planToFindAJob: null
            }
        };
    },
    created () {
        this.member = this.value;

        for (const prop in this.emptyMembersData) {
            if (!Object.prototype.hasOwnProperty.call(this.member, prop)) {
                this.$set(this.member, prop, this.emptyMembersData[prop]);
            }
        }
    },
    computed: {
        ...mapGetters('sheet', ['getJoblessQuestions']),
        otherExpectations () {
            if (this.member == null) return false;
            return this.member.selectedExpectations.includes(113);
        },
        otherAnnouncements () {
            if (this.member == null) return false;
            return this.member.selectedAnnouncements.includes(119);
        },
        selectedJobRefusal () {
            if (this.member == null) return false;
            return this.member.selectedJobRefuse.includes(124);
        },
        howLongItems () {
            return this.getResources(this.getJoblessQuestions.members.howLong);
        },
        expectationsList () {
            return this.getResources(this.getJoblessQuestions.members.selected_expectations);
        },
        announcementsList () {
            return this.getResources(this.getJoblessQuestions.members.selected_announcements);
        },
        jobRefuseList () {
            return this.getResources(this.getJoblessQuestions.members.selected_job_refuse);
        },
        showRefusedJobQuestion () {
            const members = this.getJoblessQuestions.members;
            // 'has' is imported from lodash. Is equivalent to haswonproperty but with null check. More https://stackoverflow.com/a/32232115
            if (this.member.interviewsCount > 0 && has(members, 'refused_job')) {
                return true;
            }
            if (!has(members, 'interviews_count') && has(members, 'refused_job')) {
                return true;
            }
            return false;
        },
        showSelectedJobRefusedQuestion () {
            const joblessMembers = this.getJoblessQuestions?.members;
            const joblessMembersHasSelectedJobRefuse = has(joblessMembers, 'selected_job_refuse');

            if (
                joblessMembers &&
        joblessMembersHasSelectedJobRefuse &&
        this.member.refusedJob === 'yes' &&
        this.member.interviewsCount > 0
            ) {
                return true;
            }

            if (
                joblessMembers &&
        joblessMembersHasSelectedJobRefuse &&
        !has(joblessMembers, 'interviews_count') &&
        this.member.refusedJob === 'yes'
            ) {
                return true;
            }
            return false;
        }
    },
    watch: {
        member: {
            handler: function (val) {
                this.$emit('input', val);
            },
            deep: true
        },
        selectedJobRefusal (val) {
            if (val === false) {
                this.member.jobRefuseOther = null;
            }
        },
        otherAnnouncements (val) {
            if (val === false) {
                this.member.otherAnnouncement = null;
            }
        },
        otherExpectations: {
            handler (val) {
                if (val !== true) {
                    if (this.member && has(this.member, 'otherExpectation')) {
                        this.member.otherExpectation = null;
                    }
                }
            },
            immediate: true
        },
        'member.obstacles' (val) {
            if (val === 'no') {
                this.member.obstaclesDescription = null;
            }
        },
        'member.lookingForWork': {
            handler (val) {
                if (val === 'yes') {
                    this.member.notLookingForWorkExplain = null;
                } else {
                    this.$nextTick(() => {
                        this.member.selectedAnnouncements = [];
                        this.member.foundInteresting = null;
                        this.member.jobInvitation = null;
                        this.member.cvCount = null;
                    });
                }
            }
        },
        'member.interviewsCount': {
            handler (val) {
                if (val < 1) {
                    this.member.interviewsExplain = null;
                }
            }
        },
        'member.otherAnnouncements': {
            handler (val) {
                if (val === 'no') {
                    this.member.otherAnnouncement = null;
                }
            }
        },
        'member.selectedJobRefusal': {
            handler (val) {
                if (val === 'no') {
                    this.member.jobRefuseOther = null;
                }
            }
        },
        'member.participates': {
            handler (val) {
                if (val === 'no') {
                    this.member.participatesExplain = null;
                }
            }
        },
        'member.refusedJob': {
            handler (val) {
                if (val === 'no') {
                    this.$nextTick(() => {
                        this.member.selectedJobRefuse = [];
                    });
                }
            }
        },
        value: {
            handler (val) {
                this.member = val;
            },
            deep: true
        }
    },
    methods: {
        compoundVVName (name) {
            return name + this.member.id;
        }
    }
};
</script>

<style scoped></style>
